<template>
    <div class="mod-home">
        <h3>项目介绍</h3>
    </div>
</template>

<script>
    export default {
    }
</script>

<style>
    .mod-home {
        line-height: 1.5;
    }
</style>




// WEBPACK FOOTER //
// src/views/common/home.vue